import { FC } from "react";

export const AppointmentSchedule: FC = () => {
    return(
        <h1>AppointmentSchedule</h1>
    );
}
